import type { FaireProductEntity } from "../../entity_types/product";

export const p_3sxuxp5mdh: FaireProductEntity = {
  token: "p_3sxuxp5mdh",
  type: "product",
  name: "Butternut & Rosemary Pasture-Raised Chicken Bone Broth 14oz",
  brandToken: "b_3nwax652hv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/186a0fd4a1ffac28d19bed81f2b3702fc36d86c0a6f6defb2cd6f90427ea1567.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6017fb313bd5187a63c36f8222a7690d1a362ca2ea6458ad305051a7d4ef8335.png",
    "https://cdn.faire.com/fastly/0672279e1fc19dc80fa65813053a3a5f5e1f365e5532ce96dc78b92ba1e9f82e.png",
    "https://cdn.faire.com/fastly/c1d41923742a51a00b3527e4a8ad7e5af9f426eb282a72ecf4dcffcf50286655.png",
    "https://cdn.faire.com/fastly/e08b9fc8630fec47067ab6d886425b8337beea8dfef3198b639d1b49637c59ab.png",
    "https://cdn.faire.com/fastly/e9a3e7282436994217f5c91c5bb9daee4224b9a2fd46c21cbd317cc95a93bd08.png",
    "https://cdn.faire.com/fastly/02d91fd66872cb4f0dce858b0f64df551cee3ea9323120a6c42956190c10ff6d.png",
  ],
  priceDollars: 8.31,
  description:
    'Infused with smoky chipotle, fresh rosemary, and rich butternut squash, Conductor has gained a cult following. We love sipping on Conductor warmed gently out of the jar, but it’s also perfect for a variety of recipes, and especially fall favorites like soups and chili. \n\nA note on our sourcing: we only use we only use pasture-raised regenerative bones and organic herbs and veggies - no hormones, GMOs, added sugar, antibiotics or preservatives. From brew to jar, we also utilize a 100% plastic-free process, and all of our broths are shelf-stable!\n\nSold in packs of 4 - trust us, you’ll go through it faster than you think! \n\n"Butternut & Rosemary is by FAR my favorite flavor! So yummy!" -Stephanie A.',
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:20.612Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
